import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  constructor(private http: HttpClient) {}

  public get(params): Observable<any> {
    params['client'] = environment.supplierConfig.clientName;
    return this.http.get<any>(
      `${environment.api_url_v1}/services/document/document`,
      { params },
    );
  }

  public getByStateLicense(stateLicense: string): Observable<any> {
    const params: any = {
      state_license: stateLicense,
      type: 'state_license',
      client: environment.supplierConfig.clientName
    };
    return this.http.get<any>(
      `${environment.api_url_v1}/services/document/document/by_state_license`,
      { params }
    );
  }

  public copyFromStateLicense(payload: { state_license: string; facility_id: number; company_id: number }): Observable<any> {
    const body = {
      ...payload,
      client: environment.supplierConfig.clientName
    };
    return this.http.post<any>(
      `${environment.api_url_v1}/services/document/document/copy_from_state_license`,
      body
    );
  }

  set(data): Observable<any> {
    data.forEach(item => {
      item['client'] = environment.supplierConfig.clientName;
    });
    return this.http.post<any>(
      `${environment.api_url_v1}/services/document/document`,
      data,
    );
  }

  upload(data): Observable<any> {
    data['client'] = environment.supplierConfig.clientName;
    return this.http.post<any>(
      `${environment.api_url_v1}/services/document/document/upload`,
      data,
    );
  }

  public delete(id): Observable<any> {
    return this.http.delete<any>(
      `${environment.api_url_v1}/services/document/document/${id}`,
    );
  }
}
